export default __webpack_public_path__ + "static/media/simpsons-mark-head.f53817aa.png";